/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { BomTab } from '@/app/(client)/my-styles/-components/BomTab';
import { bomHeadersQueryOptions } from '@/app/(client)/my-styles/-hooks/useBomHeaders';
import { bomPlacementsQueryOptions } from '@/app/(client)/my-styles/-hooks/useBomPlacements';
import { isEntityKindPath } from '@/app/(client)/my-styles/-hooks/useEntityDetail';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/my-components/(pages)/(detail)/$kind/$id/bom',
)({
  loader: ({ params }) => {
    if (!isEntityKindPath(params.kind)) return;
    return Promise.all([
      queryClient.ensureQueryData(bomHeadersQueryOptions(params.id)),
      queryClient.ensureQueryData(bomPlacementsQueryOptions()),
    ]);
  },
  component: BomRoute,
});

function BomRoute() {
  const { kind, id } = Route.useParams();
  if (!isEntityKindPath(kind)) return null;
  return <BomTab kind={kind} id={id} />;
}
